export default __webpack_public_path__ + "static/7-48c0ef690920b01265eec9e3ea6c133b.jpg";